import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import db from "../../../db/index.json";
import PropertyTable from "../properties/propertiesTable";
import MainSection from "./property-detail/main";
import FilterPopup from "../../popup/filterPopup";
import DetailMain from "../maintenance/maintanance-detail/detailMain";
import DetailLeaseMain from "../leases/leaseDetail/main";

const PropertySection = ({ toggleMaintainanceTable, toggleLandlordTable }) => {
  const { properties } = db;

  const [showTable, setShowTable] = useState("table"); // Default: Table show ho raha hai
  const [showFilter, setShowFilter] = useState(false);
  const [recordId, setRecordId] = useState();
  const [showDetail, setShowDetail] = useState("");
  const [recordLeaseId, setLeaseRecordId] = useState();
  const [propertyId, setPropertyId] = useState();
  const [search, setSearch] = useState("");

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (id) => {
    setPropertyId(id);
    localStorage.setItem("propertid", id);
    setShowTable("detail"); // State toggle karein
  };

  const toggleDetailProperty = () => {
    const savedUserName = localStorage.getItem("propertid");
    setPropertyId(savedUserName);
    setShowTable("detail");
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };

  const handleCreateLease = () => {
    setShowTable("createLease"); // State toggle karein
  };

  const toggleDetailMaintain = () => {
    setShowTable("MaintainanceDetails");
  };

  const toggleLeaseDetail = (status, id) => {
    setShowDetail(status);
    setLeaseRecordId(id);
    setShowTable("detailLease"); // State toggle karein
  };

  return (
    <div>
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div className="h-screen w-full">
                <div className="h-[10vh]">
                  <SearchBar
                    title={properties.title}
                    desc={properties.desc}
                    onSubmit={openPopup}
                    value={search}
                    onSearchChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    isFilter={true}
                  />
                </div>
                <div className="h-[90vh]">
                  <PropertyTable
                    onViewDetails={(id) => {
                      toggleDetail(id);
                    }}
                    searchTerm={search}
                  />
                </div>
              </div>
            );
          case "detail":
            return (
              <MainSection
                propertyId={propertyId}
                onLandlordTable={toggleLandlordTable}
                onBack={toggleTable}
                onViewDetailsMaintain={(item) => {
                  setRecordId(item);
                  toggleDetailMaintain(item);
                }}
                onMaintainancePage={toggleMaintainanceTable}
                onCreateLease={handleCreateLease}
                toggleLeaseDetail={toggleLeaseDetail}
              />
            );
          case "MaintainanceDetails":
            return (
              <DetailMain
                recordId={recordId._id}
                onBack={toggleDetailProperty}
              />
            );
          case "detailLease":
            return (
              <DetailLeaseMain
                onBack={toggleDetailProperty}
                showDetailStatus={showDetail}
                recordId={recordLeaseId}
              />
            );
          default:
            break;
        }
      })()}
      {showFilter && <FilterPopup onBack={closePopup} onFilter={closePopup} />}
    </div>
  );
};

export default PropertySection;
